export function saveReceiverLicense({ commit }, value) {
  commit("setReceiverLicense", value);
}

export function savePickUpDate({ commit }, value) {
  commit("setPickUpDate", value);
}

export function saveDropOffDate({ commit }, value) {
  commit("setDropOffDate", value);
}

export function saveIsDropOff({ commit }, value) {
  commit("setIsDropOff", value);
}

export function savePackageModel({ commit }, value) {
  commit("setPackageModel", value);
}

export function savePackageTiming({ commit }, value) {
  commit("setPackageTiming", value);
}

export function clearTransferForm({ commit }) {
  commit("resetTransferForm");
}
